module.exports = __webpack_public_path__ + "img/onlylead00.e532cc3d.jpg";